import NoDataImg from './no-data.png';
import LoadingGif from './loading.gif';
import {mediaMatch} from "../../utils";
import {useEffect} from "react";
import useNotice from "../../hooks/useNotice";
import {useTranslation} from "react-i18next";

function Loading({ loading }) {
  const { t } = useTranslation();
  const isMdmax = mediaMatch.isMdmax;
  const notice = useNotice();
  
  useEffect(() => {
    if (loading) {
      notice.loading(t('加载中...'));
    } else {
      notice.hide();
    }
  }, [loading]);
  
  return (
    loading && !isMdmax
      ? <div className={`absolute w-[100%] h-[100%] z-50 text-center`}
             style={{ backgroundColor: 'rgba(255,255,255,0.8)' }}>
        <img className="inline-block pt-[12%]"
             src={LoadingGif}
             style={{ opacity: 0.45, width: 40, marginBottom: 20 }}/>
        <p className="text-2xl text-[#666] text-center">
          loading...
        </p>
      </div>
      : null
  );
}

function Empty({ children, className = '', content }) {
  
  return (
    <div className={`relative min-h-[70vh] mdmax:min-h-[80vh] w-[100%] text-center ${className}`}>
      {
        children ? children
          : <>
            <img src={NoDataImg}
                 className="inline-block pt-[20px] mdmax:pt-[24%] md:w-[350px] mdmax:w-[55%]"/>
            <p className="text-2xl mdmax:text-[14px] text-[#666]">
              {content}
            </p>
          </>
      }
    </div>
  );
}

export default function Buffer() {
  
  return null;
}

Buffer.Loading = Loading;
Buffer.Empty = Empty;
